import { useEffect } from 'react';
import {
    Box,
    Grid,
    Typography,
} from '@mui/material';
import OnBoardingLayout from '../../../../theme/templates/on-boarding';
import ButtonHome from '../../../components/button-home';

const TermsAndConditions = () => {

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://cdn.iubenda.com/iubenda.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <OnBoardingLayout>
            <ButtonHome />
            <Grid
                sx={{
                    maxWidth: '90%',
                    width: '500px',
                    mb: 2,
                    mx: 4,
                    py: 2,
                    px: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                }}
                item
            >
                <Typography
                    component="h1"
                    variant="h3"
                    sx={{
                        mb: 8,
                        width: '100%',
                        textAlign: 'center',
                    }}
                >
                    CinemaHive Terms and Conditions
                </Typography>
                <Box
                    sx={{
                        display: 'block',
                        overflowY: 'scroll',
                        maxHeight: '600px',
                        textAlign: 'justify'
                    }}
                >
                    <div style={{ overflowY: "scroll" }}>
                        <a
                            href="https://www.iubenda.com/terms-and-conditions/13025799"
                            className="iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed"
                            title="Terms and Conditions"
                        >
                            Terms and Conditions
                        </a>
                    </div>
                </Box>

                <Typography
                    component='p'
                    variant='h5'
                    sx={{
                        marginTop: 3,
                        alignSelf: 'center',
                        color: '#feb100'
                    }}
                >
                    Scroll down to keep reading terms of service
                </Typography>
            </Grid>
        </OnBoardingLayout>
    )
};

export default TermsAndConditions;